import React, { Fragment, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { Button, CircularProgress } from '@material-ui/core';
import { IsEmpty } from '../../../common/checks';
import PostTable from './table';
import { getPage } from '../../../actions/admin/pageAction';
import PostCreateModal from '../../post/postTypeModal';
import Constants from '../../../common/constants';
import apiService from '../../../services.js/apiService';

const Posts = (props) => {
  const [loading, setLoading] = useState(false);
  const [redirectUrl, setRedirectUrl] = useState();
  const [openPostTypeModal, setOpenPostTypeModal] = useState(false);
  const [noOfLivePosts, setNoOfLivePosts] = useState(0);
  const [pageType, setPageType] = useState();

  const createPost = async (data) => {
    try {
      const payload = {
        pageId:    props.match.params.id,
        type:      data.postType,
        promoType: data.promoType,
      };
      const post = await apiService.addPost(payload);
      if (post) {
        setOpenPostTypeModal(false);
        setRedirectUrl(`/admin/page/${props.match.params.id}/post/${post.id}`);
      } else {
      setOpenPostTypeModal(false);
      }
    } catch (err) {
      toast.error(err);
    }
  };

  const getLivePosts = async () => {
    try {
      const pageId = props.match.params.id;

      if (!IsEmpty(pageId)) {
        setLoading(true);
        const posts = await apiService.getPostsByParamsForPage({}, pageId);
        if (!IsEmpty(posts.rows)) {
          setNoOfLivePosts(posts.totalCount);
        }

        setLoading(false);
      }
    } catch (err) {
      setLoading(false);
      toast.error(err.message);
    }
  };

  const fetchPage = async () => {
    try {
      const pageId = props.match.params.id;

      if (!IsEmpty(pageId)) {
        const page = await props.getPage(pageId);

        if (!IsEmpty(page)) {
          if (page.type === Constants.PageType.View) {
            getLivePosts();
          }

          setPageType(page.type);
        }
      }
    } catch (err) {
      toast.error(err.message);
    }
  };

  useEffect(() => {
    fetchPage();
  }, []);

  return redirectUrl ? <Redirect to={redirectUrl} /> : (
    <>
      <div className="row" style={{ backgroundColor: '#fff', marginLeft: 1 }}>
        <div className="col-lg-12 col-12" style={{ padding: 15 }}>
          <Button onClick={() => setOpenPostTypeModal(true)} variant="contained" color="primary" size="medium">Add Post</Button>

          {pageType === Constants.PageType.View && (
            <h4 className="my-4">
              Total No of Live &amp; Searchable Highlight Posts
              { loading
                ? <CircularProgress className="ml-3" color="secondary" size="2rem" />
                : (
                  <>
                    {` - ${noOfLivePosts}`}
                  </>
                )}

            </h4>
          ) }
        </div>

        <div className="col-lg-12 col-12 card-left">
          <PostTable pageId={(props.match && props.match.params) ? props.match.params.id : ''} />
        </div>
      </div>
      {
        openPostTypeModal
          ? (
            <PostCreateModal
              onComplete={(d) => createPost(d)}
              onClose={() => setOpenPostTypeModal(false)}
            />
          )
          : <div />
      }
    </>
  );
};

Posts.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
  }).isRequired,
  getPage: PropTypes.func.isRequired,
};

export default connect(null, { getPage })(Posts);
